import React from 'react';
import { notificationTips } from '@gp/utils/common';
import { validateEmail } from '@gp/utils/validators';
import { FIELD_COMMON_ERR_MSG } from '@gp/constants/const';
import { EmailSendResultStatus } from '../enums';
import { EMAIL_ERROR_MSG } from '../constants';

import type { ITagInputValue } from '@gp/components/TagInput/types';
import type { IEmailSendResult } from '../types';
import { IRecord } from '@gp/types/global';

function isRecipientsValid(payload?: ITagInputValue | null): boolean {
  const { tags, input } = payload || {};
  const isTagsEmpty = !Array.isArray(tags) || !tags.length;

  if (isTagsEmpty && !input) return false;

  const isTagsValid = !!tags?.every((tag) => !!tag?.valid);

  const isInputValid = !!input
    ?.split(';')
    ?.filter((item) => !!item?.trim())
    ?.every((item) => validateEmail(item?.trim()));

  if (!input) return isTagsValid;

  if (isTagsEmpty) return isInputValid;

  return isTagsValid && isInputValid;
}

const notificationSendEmailErrorTips = (emails?: string[] | null) => {
  if (!Array.isArray(emails) || !emails.length) {
    notificationTips('error', 'The following email failed!');
    return;
  }

  notificationTips(
    'error',
    <>
      The following email failed!
      <br />
      {emails.join('; ')}
    </>,
    0,
  );
};

export const validateRecipients = (errors: IRecord<string>, value?: ITagInputValue | null) => {
  const { tags, input } = value || {};
  if ((!Array.isArray(tags) || !tags.length) && !input) {
    // eslint-disable-next-line no-param-reassign
    errors.recipients = FIELD_COMMON_ERR_MSG;
  } else if (!isRecipientsValid(value)) {
    // eslint-disable-next-line no-param-reassign
    errors.recipients = EMAIL_ERROR_MSG;
  }
};

export const notificationSendEmailFeedback = (
  result?: IEmailSendResult | null,
  title?: string,
  emails?: string[] | null,
) => {
  const { status } = result || {};

  if (status === EmailSendResultStatus.Success) {
    const successTips = !title ? 'Email sent successfully!' : `${title} email sent successfully!`;
    // 全部发送成功
    notificationTips('success', successTips);
  } else if (status === EmailSendResultStatus.Partial) {
    // 部分发送成功，部分发送失败
    notificationSendEmailErrorTips(emails);
  } else if (status === EmailSendResultStatus.Failed) {
    // 全部发送失败
    notificationSendEmailErrorTips(emails);
  }
};
